/* eslint-disable no-inner-declarations */
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { CancelButton, ConfirmButton, Container, StyledGrid, StyledTable, StyledTableContainer } from "./Styled";


const FMRegularFormComponent = ({
	fields,
	options,
	handleConfirm,
	handleCancel,
	disableSubmit,
	renderFields,
}) => {

	let isModal = options?.modal;

	return (
		<>
			<Container isModal>
				<StyledTableContainer isModal component={isModal ? Box : Paper} className="!p-3 !rounded-md">
					<StyledTable aria-label="customized table ">
						<TableBody>
							{Array.isArray(fields) &&
								fields?.map((field, index) => {
									return (
										<TableRow key={index}>
											{renderFields(field, false)}
										</TableRow>
									)
								})}
						</TableBody>
					</StyledTable>
				</StyledTableContainer>
			</Container>
			
			{(options?.confirm || options?.cancel) && (
				<StyledGrid
					container
					spacing={2}
					isModal
					marginBottom="6px"
					marginTop="0px"
					paddingBottom="8px"
					justifyContent="left"
				>
					<Grid>
						{options?.confirm && (
							<ConfirmButton
								variant="contained"
								disabled={disableSubmit}
								onClick={() => handleConfirm()}
							>
								{options?.confirm}
							</ConfirmButton>
						)}
					</Grid>
					<Grid>
						{options?.cancel && (
							<CancelButton
								variant="outlined"
								onClick={() => handleCancel()}
							>
								{options?.cancel}
							</CancelButton>
						)}
					</Grid>
				</StyledGrid>
			)}
		</>
	);
}

export default FMRegularFormComponent;
